import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Contact3DPageTest } from './contact3d/gamePages/Contact3DPageTest';
import { Contact3DPage } from './contact3d/gamePages/Contact3DPage';
import { GameSettingsKeys, initGameSettings } from './core/util/UseGameSetting';
import { RenderingModeSetting } from './core/components/RenderingModeCheckbox';
import { initScreenSize } from './core/util/MediaQueries';
import { Contact3DStartPage } from './contact3d/gamePages/Contact3DStartPage';
import { HomePage } from './landingPages/HomePage';
import { NotFoundPage } from './landingPages/NotFoundPage';
export const App = () => {
    initGameSettings({
        [GameSettingsKeys.RenderingMode + '0']: RenderingModeSetting.ThreeJS,
        [GameSettingsKeys.RenderingMode + '1']: RenderingModeSetting.ThreeJS,
        [GameSettingsKeys.RenderingMode + '2']: RenderingModeSetting.ThreeJS,
        [GameSettingsKeys.RenderingMode + '3']: RenderingModeSetting.ThreeJS,
    });
    initScreenSize();
    return (_jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: '/', element: _jsx(HomePage, {}) }), _jsx(Route, { path: "/contact/:gameId", element: _jsx(Contact3DPage, {}) }), webpackEnv.stage === 'staging' && _jsx(Route, { path: "/contact/:gameId/test", element: _jsx(Contact3DPageTest, {}) }), _jsx(Route, { path: '/contact', element: _jsx(Contact3DStartPage, {}) }), _jsx(Route, { path: '*', element: _jsx(NotFoundPage, {}) })] }) }));
};
//# sourceMappingURL=App.js.map